export default function InnovationSection() {
  return (
    <section className="relative py-24 md:py-32 lg:py-40 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20composition%20with%20warm%20amber%20and%20cream%20tones%2C%20soft%20layered%20translucent%20geometric%20forms%2C%20smooth%20organic%20curves%20blending%20into%20a%20minimalist%20backdrop%2C%20elegant%20atmospheric%20depth%2C%20gentle%20light%20bleeding%20through%20layers%2C%20modern%20abstract%20art%20aesthetic%2C%20professional%20sophisticated%20tone%2C%20no%20hard%20edges%2C%20dreamy%20diffused%20look&width=1600&height=700&seq=innovation-bg-elr-02&orientation=landscape"
          alt="Abstract flowing composition with warm amber tones and soft geometric forms"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-950/85"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto">
        <div className="mb-4">
          <span className="text-xs tracking-widest uppercase text-white/40" style={{ fontFamily: 'var(--font-label)' }}>
            (vision)
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-10 md:mb-14" style={{ fontFamily: 'var(--font-heading)' }}>
          Continuously
          <br />
          <span className="text-white/40">evolving forward</span>
        </h2>

        <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-2xl" style={{ fontFamily: 'var(--font-body)' }}>
          The technology landscape never stands still, and neither do we. Our team actively explores emerging technologies, refines internal processes, and adopts evolving engineering standards to ensure every solution remains relevant, robust, and forward-compatible. This culture of continuous improvement is embedded in how we think, build, and deliver.
        </p>
      </div>
    </section>
  );
}